import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=71e40854"
import script from "./FormWrapper.vue?vue&type=script&lang=ts"
export * from "./FormWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e40854')) {
      api.createRecord('71e40854', component.options)
    } else {
      api.reload('71e40854', component.options)
    }
    module.hot.accept("./FormWrapper.vue?vue&type=template&id=71e40854", function () {
      api.rerender('71e40854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormWrapper.vue"
export default component.exports